import { type PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import { TYPO_STYLES } from "@/styles/typography";

export const ErrorView = ({ children }: PropsWithChildren) => {
    return (
        <span
            className={twMerge(TYPO_STYLES.error(), "block border-2 border-redError p-4 w-full ")}
        >
            {children}
        </span>
    );
};
